import { useCallback } from 'react';
import { useRouter } from '@tanstack/react-router';

// „Zurück" heißt: dorthin, wo ich herkam (Befund 29.10.2026).
//
// Bis hierher sprangen die Zurück-Knöpfe fest auf eine Adresse — die
// Detailansicht etwa immer auf das leere Dashboard. Wer aus einer Suche
// in einen Treffer ging, verlor beim Zurückgehen Suche, Filter und
// Bildlaufposition. Am PC fiel das weniger auf (Zurück-Taste des
// Browsers), in der App vom Home-Bildschirm gibt es keine solche Taste:
// dort IST der Knopf der Weg zurück.
//
// Jetzt: ein Schritt zurück im Verlauf DIESER Anwendung. Nur wenn es
// keinen gibt — die Seite wurde direkt geöffnet, per QR-Scan oder Link —,
// führt der Knopf zum festen Ziel. `canGoBack()` zählt nur Schritte
// innerhalb der Anwendung (der Router führt einen eigenen Index), eine
// fremde Seite davor zählt nicht.

export type ZurueckZiel = { to: string; params?: Record<string, string> };

export function useZurueck(ersatz: ZurueckZiel): () => void {
  const router = useRouter();
  const { to, params } = ersatz;
  const paramsSchluessel = JSON.stringify(params ?? {});
  return useCallback(() => {
    if (router.history.canGoBack()) {
      router.history.back();
      return;
    }
    void router.navigate({
      to,
      params: JSON.parse(paramsSchluessel) as Record<string, string>,
      replace: true
    } as never);
  }, [router, to, paramsSchluessel]);
}
